"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIONAL_MOVE = exports.ChessTermType = exports.TermAction = exports.MoveType = void 0;
__exportStar(require("./websocketRequests"), exports);
__exportStar(require("./websocketResponses"), exports);
__exportStar(require("./challenge"), exports);
var MoveType;
(function (MoveType) {
    MoveType["BLUNDER"] = "blunder";
    MoveType["MISTAKE"] = "mistake";
    MoveType["INACCURACY"] = "inaccuracy";
    MoveType["GOOD"] = "good";
    MoveType["EXCELLENT"] = "excellent";
    MoveType["BEST"] = "best";
    MoveType["GREAT"] = "great";
    MoveType["BRILLIANT"] = "brilliant";
    MoveType["BOOK"] = "book";
})(MoveType = exports.MoveType || (exports.MoveType = {}));
var TermAction;
(function (TermAction) {
    TermAction["ALLOW"] = "allow";
    TermAction["ALLOW_UNDEFENDED"] = "allow undefended";
    TermAction["MISS"] = "miss";
    TermAction["BETTER_WAY"] = "better way";
    TermAction["PERFORM"] = "perform";
    TermAction["POSPONE"] = "pospone";
    TermAction["CREATE"] = "create";
    TermAction["PERFORM_THREAT"] = "threat";
    TermAction["MISS_THREAT"] = "miss threat";
    TermAction["ALLOW_THREAT"] = "allow threat";
})(TermAction = exports.TermAction || (exports.TermAction = {}));
// export enum AffectNextMove {
//   FORCE = "force",
//   OFFER_TRADE = "offer trade",
// }
var ChessTermType;
(function (ChessTermType) {
    // Change in material
    ChessTermType["OFFER_TRADE"] = "offer trade";
    ChessTermType["OFFER_TRADE_SAME_PIECE"] = "offer trade same piece";
    // Attacks
    ChessTermType["KICK_PIECE"] = "kick";
    ChessTermType["TEMPO"] = "tempo gain";
    ChessTermType["THREATEN_PIECE"] = "threaten piece";
    ChessTermType["THREATEN_TRADE"] = "threaten trade";
    ChessTermType["THREATEN_CHECKMATE"] = "threaten checkmate";
    // Pawns
    ChessTermType["DOUBLE_PAWN"] = "double pawn";
    ChessTermType["FORCE_DOUBLE_PAWN"] = "force double pawn";
    ChessTermType["BACKWARD_PAWN"] = "backward pawn";
    ChessTermType["PAWN_CHAIN"] = "pawn chain";
    ChessTermType["ATTACK_PAWN_CHAIN"] = "attack pawn chain";
    ChessTermType["BLOCKADE"] = "blockade";
    ChessTermType["ISOLATED_PAWN"] = "isolated pawn";
    ChessTermType["FORCE_ISOLATE_PAWN"] = "force isolate pawn";
    ChessTermType["CONNECT_PAWN"] = "connect pawn";
    ChessTermType["OFFER_TRADE_CONNECT_PAWN"] = "offer trade connect pawn";
    ChessTermType["PASSED_PAWN"] = "passed pawn";
    ChessTermType["OFFER_TRADE_PASSED_PAWN"] = "offer trade passed pawn";
    // Defence
    ChessTermType["BLOCK"] = "block";
    ChessTermType["DEFEND"] = "defend";
    ChessTermType["MOVE_TO_SAFETY"] = "move to safety";
    ChessTermType["IN_CHECK_MOVE_TO_SAFETY"] = "in check move to safety";
    ChessTermType["IN_CHECK_BLOCK"] = "in check block";
    ChessTermType["IN_CHECK_ESCAPE"] = "in check escape";
    ChessTermType["COUNTER_ATTACK"] = "counter attack";
    // Piece placement
    ChessTermType["CENTER_CONTROL"] = "center control";
    ChessTermType["KING_SAFETY"] = "king safety";
    ChessTermType["BAD_KING_SAFETY"] = "bad king safety";
    ChessTermType["OUTPOST"] = "outpost";
    ChessTermType["PIECE_ACTIVITY"] = "piece activity";
    ChessTermType["CASTLE"] = "castle";
    ChessTermType["CAN_CASTLE"] = "CAN_CASTLE";
    // Strategic Concepts
    ChessTermType["OPEN_FILE"] = "open file";
    ChessTermType["OPEN_DIAGONAL"] = "open diagonal";
    ChessTermType["CHALLENGE_OPEN_FILE"] = "challenge open file";
    ChessTermType["CHALLENGE_OPEN_DIAGONAL"] = "challenge open diagonal";
    ChessTermType["SACRIFICE"] = "sacrifice";
    // BAD_SACRIFICE = "bad sacrifice",
    ChessTermType["CONNECT_ROOKS"] = "connect rooks";
    ChessTermType["CONNECT_QUEEN_AND_BISHOP"] = "connect queen and bishop";
    // Opening Concepts
    ChessTermType["BOOK_MOVE"] = "book move";
    ChessTermType["DEVELOP_QUEEN_EARLY"] = "develop queen early";
    ChessTermType["DEVELOPMENT"] = "development";
    ChessTermType["ACTIVATE_ROOK"] = "activate rook";
    ChessTermType["ACTIVATE_QUEEN"] = "activate queen";
    ChessTermType["MOVE_DEVELOPED_PIECE"] = "move developed piece";
    ChessTermType["BAD_OPENING_MOVE"] = "bad opening move";
    // Ending game
    ChessTermType["CHECKMATE"] = "checkmate";
    ChessTermType["FOLLOW_CHECKMATE"] = "follow checkmate";
    ChessTermType["DRAW"] = "draw";
    ChessTermType["STALE_MATE"] = "stale mate";
    ChessTermType["TRADE"] = "trade";
    ChessTermType["BAD_TRADE"] = "bad trade";
    ChessTermType["RETAKE"] = "retake";
    ChessTermType["TAKES_BACK"] = "takes back";
    ChessTermType["DIRECT_MATERIAL_LOSS"] = "direct material loss";
    ChessTermType["DIRECT_MATERIAL_WIN"] = "direct material win";
    ChessTermType["MATERIAL_WIN"] = "material win";
    ChessTermType["EVENTUAL_MATERIAL_WIN"] = "eventual material win";
    // Tactical Concepts
    ChessTermType["TACTIC"] = "tactic";
    // TACTIC_THREAT = "tactic threat",
    ChessTermType["FORK"] = "fork";
    ChessTermType["PIN"] = "pin";
    ChessTermType["SKEWER"] = "skewer";
    ChessTermType["DOUBLE_ATTACK"] = "double attack";
    ChessTermType["DISCOVERED_ATTACK"] = "discovered attack";
    ChessTermType["UNPIN"] = "unpin";
    ChessTermType["REMOVE_DEFENDER"] = "remove defender";
    ChessTermType["OVERLOADING"] = "overloading";
    ChessTermType["DEFLECTION"] = "deflection";
    ChessTermType["TRAPPED_PIECE"] = "trapped piece";
    // Initiative changes
    ChessTermType["INITIATIVE_CHANGE"] = "initiative change";
    ChessTermType["EQUAL_TO_ADVANTAGE"] = "equal to advantage";
    ChessTermType["ADVANTAGE_TO_EQUAL"] = "advantage to equal";
    ChessTermType["NONE"] = "none";
})(ChessTermType = exports.ChessTermType || (exports.ChessTermType = {}));
exports.OPTIONAL_MOVE = "-";
// export interface GameReviewEvalPosition {
//   fen: string;
//   move: string;
//   depth: number;
//   score: number;
//   expectedPoints: number;
//   type: MoveType;
//   bestMove: string;
//   pvMoves: string[];
//   mateInMoves?: number;
//   moveIndex: number;
// }
//# sourceMappingURL=index.js.map